import { FACEBOOK_POST_REACH } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function fbPostReach(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case FACEBOOK_POST_REACH:
    
      // const parsedData = JSON.parse(action.payload.data)
      
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}